import { template as template_261d0fca4b3e4726b2fc1b74d83e8566 } from "@ember/template-compiler";
import OnInsert from 'client-portal/modifiers/on-insert';
import RequestClinicianSearchFiltersApplyFooter from './apply-footer';
import RequestClinicianSearchFiltersPanelLoadingState from './panel-loading-state';
export default template_261d0fca4b3e4726b2fc1b74d83e8566(`
  <div
    class="{{@class}} {{if @isLoading 'loading'}}"
    data-test-clinician-search-filter-panel={{@facetKey}}
    {{OnInsert @onLoad}}
    ...attributes
  >
    {{#if @isLoading}}
      <RequestClinicianSearchFiltersPanelLoadingState
        @ariaLabel={{@loadingAriaLabel}}
        data-test-clinician-search-filter-options-loading={{@facetKey}}
      />
    {{else}}
      {{yield}}

      {{#unless @hideApply}}
        <RequestClinicianSearchFiltersApplyFooter
          @disabled={{@applyDisabled}}
          @onApply={{@onApply}}
        />
      {{/unless}}
    {{/if}}
  </div>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
